import { computed, type ComputedRef } from 'vue';
import { useBranchTheme } from '@/entities/Branch';
import { useUserStore } from '@/entities/User';

/**
 * Associação do usuário na filial selecionada.
 *
 * É um id de membro, e não de usuário: é ele que as linhas de Homologação comparam contra
 * `document.memberId` e `approvalManagerId` para decidir "criado por mim" e "direcionado a mim".
 */
export function useCurrentMemberId(): ComputedRef<number | null> {
  const { getCurrentSelectedBranch } = useBranchTheme();
  const userStore = useUserStore();

  return computed(() => {
    const selectedBranchId = Number(getCurrentSelectedBranch());
    if (selectedBranchId) {
      const membership = userStore.user?.memberships?.find(
        (item) => Number(item.branchId) === selectedBranchId
      );
      if (membership?.id != null) {
        return membership.id;
      }
    }

    return userStore.user?.memberships?.[0]?.id ?? null;
  });
}
